import React from "react"
import {StyledAutocompleteContainer} from "./components"

const Club25AutocompleteContainer = ({props, children}: any) => {
    return (
        <StyledAutocompleteContainer data-testid="header-enrich-auto-complete" {...props}>
            {children}
        </StyledAutocompleteContainer>
    )
}

export default Club25AutocompleteContainer
